import { render, staticRenderFns } from "./CardTarjaDefaultTwitter.vue?vue&type=template&id=25baeb72&scoped=true"
import script from "./CardTarjaDefaultTwitter.vue?vue&type=script&lang=js"
export * from "./CardTarjaDefaultTwitter.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaDefaultTwitter.vue?vue&type=style&index=0&id=25baeb72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25baeb72",
  null
  
)

export default component.exports